
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Temesta, Seresta, Lexotanil, Dormicum oder Xanax: Das alles sind Namen von sogenannten Benzodiazepinen, die den grössten Anteil unter den Schlaf- und Beruhigungsmitteln ausmachen. `}<M mdxType="M">{`Sie gehören zu den meistverschriebenen Medikamenten überhaupt, obwohl sie einige Tücken haben.`}</M>{` Im Schnitt wird jeder Zehnte, der Benzodiazepine länger einnimmt, abhängig, schätzt Marc Vogel vom Zentrum für Abhängigkeitserkrankungen der Universitären Psychiatrischen Kliniken in Basel. `}<M mdxType="M">{`Zu den möglichen Nebenwirkungen gehören Müdigkeit, Schwindel, Konzentrations- und Gedächtnisstörungen oder auch Verwirrtheit.`}</M>{` Eine unterschätzte Nebenwirkung – zumindest bei älteren Menschen – ist zudem die erhöhte Sturzgefahr. Die muskelentspannende Wirkung von Benzodiazepinen kann zu einem unsicheren Gang und in der Folge zu Stürzen, Schürfwunden und Brüchen führen. `}<br /><br />{`
Grundsätzlich gilt, so Vogel: «Je länger die Einnahme und je höher die Dosis, desto eher ist mit unerwünschten Folgen zu rechnen.» `}<M mdxType="M">{`Beim Absetzen der Medikamente kann sich zudem der Schlaf deutlich verschlechtern.`}</M>{` Die Schlaflosigkeit kann kurzfristig schlimmer sein als zuvor. Neben Schlafstörungen können auch Unruhe und Angst auftreten. Häufig sind es genau solche Beschwerden, die mit den Mitteln eigentlich gelindert werden sollen. Die Entzugssymptome dauern meistens einige Tage. Eine vierwöchige Einnahme reicht bei diesen Medikamenten aus, um nach dem Absetzen Schlafstörungen zu verursachen. Je länger die Tabletten eingenommen wurden, desto ausgeprägter sind die Beschwerden, die sich dann auch über Wochen hinziehen können.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;